<template>
  <div class="columns">
    <div class="column">
      <b-message v-if="threads !== undefined && threads.length === 0" type="is-info" has-icon>
        <h1 class="is-size-4">You currently have no scheduled tweets or threads</h1>
        <div class="content">
          <ul>
            <li>To schedule a thread, click on "Schedule" from the
              <router-link to="/app/">Compose</router-link> page.</li>
            <li>Looking for a scheduled thread that should be here?
              Schedules are store on a per-account basis.
              Try <a href="#" @click.prevent="$store.commit('setTrigger', 'selectAccount')">switching accounts</a>
              if it is saved under another account.
            </li>
          </ul>
        </div>
      </b-message>
      <div v-else v-for="thread in threads" :key="thread.id">
        <div class="box is-flex mb-2 is-clickable is-align-items-center" @click.prevent="$store.dispatch('setThreadFromDB', thread)">
          <div class="p-2 is-flex-grow-1" style="width: 60%">
            <p class="draft-text"><em>{{ thread.tweets[0].text }}</em></p>
          </div>
          <div class="p-2 has-text-centered" style="width: 10%">
            <p class="heading">Tweets</p>
            <p class="title">{{ thread.tweets.length }}</p>
          </div>
          <div class="p-2 has-text-centered" style="width: 30%;">
            <p class="heading">Publishing in</p>
            <p class="title is-size-4">{{ getTimeUntil(thread.scheduled_for) }}</p>
          </div>
          <div class="p-2 has-text-centered">
            <a href="#" @click.stop="unschedule(thread)" title="Unschedule tweet and edit.">
              <b-icon icon="edit" type="is-info" size="is-large"></b-icon>
            </a>
          </div>
          <div class="p-2 has-text-centered">
            <a href="#" @click.stop="deleteSchedule(thread)" title="Permanently delete scheduled tweets.">
              <b-icon icon="times-circle" type="is-danger" size="is-large"></b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {createImageFromFile} from "../../store/modules/images";

let getFileFromUrl = async function(url) {
  const response = await fetch(url, { mode: 'cors' })
  const name = url.substring(url.lastIndexOf('/') + 1)
  const data = await response.blob()
  return new File([data], name, { type: data.type })
}

import {formatDistanceToNow, parseISO} from "date-fns";
import tweets from "../../api/tweets";

export default {
  name: "Outbox",

  data() {
    return {
      threads: undefined,
    }
  },

  computed: {
    activeAccountIndex() {
      return this.$store.state.auth.activeAccountIndex
    }
  },

  created() {
    this.getData()
  },
  watch: {
    '$route': 'getData',
    activeAccountIndex: 'getData',
  },

  methods: {
    getData() {
      this.threads = undefined
      if (!this.$store.getters.isLoggedIn) return
      tweets.getOutbox().then(response => {
        this.threads = response.data
      })
    },

    getTimeUntil(val) {
      const dt = parseISO(val)
      return val === null ? '-' : (dt < new Date() ? 'now!' : formatDistanceToNow(dt, { includeSeconds: true }))
    },

    unschedule(thread) {
      this.$buefy.dialog.confirm({
        title: 'Edit scheduled thread',
        message: 'This will unschedule your thread and move it back into drafts to edit. ' +
            'You will need to reschedule it to publish it. Are you sure?',
        onConfirm: () => {
          this.$store.dispatch('createNewThread').then(() => {
            // We may duplicate images here - in theory we could track
            // the image inserts, build a map and use 'addExistingImagetoTweet'
            // however it is such a rare thing (same image, 2 tweets, scheduling and
            // de-scheduling) that it seems an unnecessary optimization.
            thread.tweets.forEach((tweet, tweet_index) => {
              this.$store.commit('insertTweet', {index: tweet_index, text: tweet.text, hasFocus: false})
              tweet.media.forEach((imageUrl, image_index) => {
                getFileFromUrl(imageUrl.file).then(file => {
                  createImageFromFile(file).then(img => {
                    this.$store.dispatch('addNewImageToTweet', {
                      tweet_index: tweet_index,
                      image_data: img
                    })
                  })
                })
              })
            })
            this.$store.commit('deleteTweet', -1)   // delete the last blank tweet make when creating the thread
            if (thread.reply_to) {
              tweets.getTweet(thread.reply_to).then(response => {
                this.$store.commit('setReplyTo', response.data)
              })
            }

            // send a delete message to the API
            tweets.deleteScheduledThread(thread.id)
            this.$router.push('/app/compose')
          })

        }
      })
    },

    deleteSchedule(thread) {
      this.$buefy.dialog.confirm({
        title: 'Delete scheduled thread',
        message: "This will permanently delete your tweets. There's no going back!\n\n" +
            "Are you sure?",
        onConfirm: () => {
          tweets.deleteScheduledThread(thread.id).then(() => {
            this.$buefy.snackbar.open({
              message: 'Thread deleted',
              position: 'is-top',
              actionText: "OK",
              duration: 3000,
            })
            this.getData()
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
